import React from 'react';
import PropTypes from 'prop-types';

const getURL = ({ isServedFromLegacySite, url, legacyURL }) => {
  const returnedURL = isServedFromLegacySite && legacyURL ? legacyURL : url;
  const isAbsoluteURL = returnedURL.match(/^http/);

  return isAbsoluteURL ? returnedURL : `/${returnedURL}`;
};

const LocaleLinks = ({ country, isServedFromLegacySite }) => country && Array.isArray(country.langs) && (
  country.langs.map(({
    name,
    url,
    legacyURL,
    slug,
  }) => (
    <a
      className="countries-wrapper__link"
      key={slug}
      data-test="countries-link"
      href={getURL({ isServedFromLegacySite, url, legacyURL })}
      aria-label={`${country.name} ${name}`}
    >
      {name}
    </a>
  ))
);

LocaleLinks.propTypes = {
  country: PropTypes.shape({
    langs: PropTypes.arrayOf(PropTypes.object),
  }),
};

export default LocaleLinks;
